import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Sparkles, Rocket, Diamond, Users, Crown, Phone, MessageCircle, Star, Flame, Trees, Waves, Building2 } from 'lucide-react';

const HERO_IMG = 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1600&q=80';

const FEATURES = [
  { icon: '🧘‍♂️', title: 'द स्पिरिचुअल कोर', text: 'ओशो और कबीर के दर्शन से प्रेरित विशाल मेडिटेशन और योगा डोम', grad: 'from-fuchsia-500/25 via-purple-500/15 to-indigo-600/25', border: 'border-fuchsia-400/50' },
  { icon: '🌊', title: 'द सेलिब्रेशन कोर', text: 'वर्ल्ड-क्लास वॉटर पार्क, वेव पूल और हाई-टेक VR गेमिंग ज़ोन', grad: 'from-cyan-500/25 via-teal-500/15 to-blue-600/25', border: 'border-cyan-400/50' },
  { icon: '🌿', title: 'द नेचर कोर', text: 'हाई-टेक गौशाला, ऑर्गेनिक फार्मिंग और 100% प्योर वेज \'फार्म टू टेबल\' रेस्टोरेंट', grad: 'from-emerald-500/25 via-green-500/15 to-lime-600/25', border: 'border-emerald-400/50' },
  { icon: '🎬', title: 'द कम्युनिटी हब', text: 'बिग प्रोजेक्टर हॉल, इवेंट सेंटर और इन-हाउस कमर्शियल मिनी-मॉल', grad: 'from-amber-500/25 via-orange-500/15 to-rose-600/25', border: 'border-amber-400/50' },
];

const TIERS = [100, 500, 1000, 5000, 10000, 50000, 100000, 500000, 5000000];

const SamadhanVision = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 text-white pb-16">
      {/* Hero */}
      <div className="relative h-[70vh] overflow-hidden">
        <img src={HERO_IMG} alt="Samadhan Center" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-slate-950" />
        <div className="absolute inset-0 opacity-30" style={{ backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(168,85,247,0.5), transparent 40%), radial-gradient(circle at 70% 70%, rgba(6,182,212,0.5), transparent 40%)' }} />
        <Link to="/samadhan" className="absolute top-4 left-4 z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/40 backdrop-blur border border-white/20 text-white text-xs font-bold hover:bg-black/60" data-testid="vision-back">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-400/20 border border-amber-300/50 text-amber-200 text-[10px] font-black uppercase tracking-widest mb-3 animate-pulse">
            <Star className="w-3 h-3" /> Launching 01 Jan 2031
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black bg-gradient-to-r from-amber-300 via-fuchsia-300 to-cyan-300 bg-clip-text text-transparent leading-tight">
            SAMADHAN CENTER 🌟
          </h1>
          <p className="mt-3 text-lg sm:text-xl text-white/90 italic max-w-2xl">
            &ldquo;Peace of Mind with the Ultimate Celebration of Life&rdquo;
          </p>
          <p className="mt-2 text-sm sm:text-base text-cyan-200 max-w-3xl">
            10 एकड़ का अल्ट्रा-लक्ज़री और आध्यात्मिक इको-रिसॉर्ट
          </p>
          <div className="mt-6 flex gap-3 flex-wrap justify-center">
            <Link to="/samadhan" className="px-6 py-2.5 rounded-full bg-gradient-to-r from-amber-500 to-orange-600 text-white font-black text-sm shadow-lg hover:scale-105 transition" data-testid="vision-cta-donate">💎 Donate Now (100 AT से शुरू)</Link>
            <a href="https://wa.me/919579369830?text=Namaste!%20Mujhe%20Samadhan%20Center%20ke%20baare%20mein%20jaanna%20hai" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 rounded-full bg-green-500 text-white font-black text-sm shadow-lg hover:scale-105 transition flex items-center gap-1.5" data-testid="vision-cta-whatsapp">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 mt-10 space-y-8">
        {/* 10X Bonus */}
        <div className="rounded-3xl border-2 border-amber-400/50 bg-gradient-to-br from-amber-500/20 via-orange-500/10 to-rose-500/20 p-6 sm:p-8 relative overflow-hidden" data-testid="vision-10x-section">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-amber-400/30 rounded-full blur-3xl" />
          <div className="flex items-center gap-2 mb-2">
            <Rocket className="w-6 h-6 text-amber-300" />
            <span className="text-[10px] uppercase tracking-widest text-amber-300 font-black">THE MASTERSTROKE</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black">🚀 THE 10X MEGA BONUS</h2>
          <p className="mt-3 text-sm sm:text-base text-white/90 leading-relaxed">
            क्या आपका आज का छोटा सा निवेश, कल आपको <span className="font-black text-amber-300">10 गुना (10X)</span> लक्ज़री दे सकता है? हाँ! आज &lsquo;अनंत वेब पोर्टल&rsquo; के माध्यम से समाधान सेंटर के लिए डोनेशन दें और <span className="font-black text-emerald-300">2031 में सेंटर के लाइव होने पर अपनी डोनेशन वैल्यू का सीधा 10X (दस गुना) लाभ पाएं!</span>
          </p>
          <div className="mt-4 rounded-2xl bg-black/50 border border-emerald-400/40 p-4">
            <div className="text-[10px] uppercase tracking-widest text-emerald-300 font-black">💡 EXAMPLE</div>
            <div className="text-lg sm:text-xl font-black text-white mt-1">
              10,000 AT का डोनेशन → <span className="text-emerald-300">₹1,00,000</span> की वर्ल्ड-क्लास सर्विसेस
            </div>
          </div>
        </div>

        {/* Donation Tiers */}
        <div className="rounded-3xl border border-fuchsia-400/40 bg-gradient-to-br from-fuchsia-950/40 to-slate-900 p-6 sm:p-8" data-testid="vision-donation-section">
          <div className="flex items-center gap-2 mb-2">
            <Diamond className="w-6 h-6 text-fuchsia-300" />
            <span className="text-[10px] uppercase tracking-widest text-fuchsia-300 font-black">DONATION MAHAKRANTI</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black">💎 डोनेशन महाक्रांति</h2>
          <p className="mt-2 text-sm text-white/80">
            एक महान विज़न में सबकी हिस्सेदारी होनी चाहिए! <span className="font-black text-amber-300">(1 AT = 1 INR)</span>
          </p>
          <div className="mt-4 grid grid-cols-3 sm:grid-cols-5 md:grid-cols-9 gap-2">
            {TIERS.map((t) => (
              <div key={t} className="rounded-xl border border-fuchsia-400/30 bg-black/40 p-2 text-center hover:scale-105 transition" data-testid={`vision-tier-${t}`}>
                <div className="text-[9px] uppercase text-slate-400">AT</div>
                <div className="text-sm sm:text-base font-black text-fuchsia-200">
                  {t >= 100000 ? `${(t / 100000).toFixed(t % 100000 ? 1 : 0)}L` : t >= 1000 ? `${t / 1000}K` : t}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4 rounded-xl bg-emerald-500/10 border border-emerald-400/40 p-3">
            <div className="text-xs sm:text-sm text-emerald-200 font-bold">
              📜 <span className="font-black">नो-लॉकिंग सर्टिफिकेट:</span> हर डोनेशन पर तुरंत डिजिटल सर्टिफिकेट पाएं, जिसे आप कभी भी लाइव रेट पर रिडीम कर सकते हैं।
            </div>
          </div>
        </div>

        {/* Features */}
        <div>
          <div className="text-center mb-5">
            <div className="text-[10px] uppercase tracking-widest text-cyan-300 font-black mb-1">✨ यहाँ क्या है खास?</div>
            <h2 className="text-2xl sm:text-3xl font-black">The Four Cores</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {FEATURES.map((f, i) => (
              <div key={i} className={`rounded-2xl border-2 ${f.border} bg-gradient-to-br ${f.grad} p-5 hover:scale-[1.02] transition`} data-testid={`vision-feature-${i}`}>
                <div className="text-4xl mb-2">{f.icon}</div>
                <h3 className="text-lg font-black mb-1">{f.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">{f.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Founder Membership */}
        <div className="rounded-3xl border-2 border-amber-300 bg-gradient-to-br from-amber-500/30 via-yellow-500/20 to-orange-600/30 p-6 sm:p-8 relative overflow-hidden" data-testid="vision-founder-section">
          <div className="absolute top-0 right-0 text-8xl opacity-10">👑</div>
          <div className="flex items-center gap-2 mb-2">
            <Crown className="w-6 h-6 text-amber-200" />
            <span className="text-[10px] uppercase tracking-widest text-amber-200 font-black">EXCLUSIVE · ONLY 200 SEATS</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black">👑 VIP LIFETIME FOUNDER MEMBERSHIP</h2>
          <p className="mt-3 text-sm sm:text-base text-white/90 leading-relaxed">
            सिर्फ <span className="font-black text-amber-200">200 लोगों</span> के लिए सुनहरा अवसर! <span className="font-black text-amber-200">1 करोड़ (1 Crore AT)</span> का डोनेशन दें और &lsquo;समाधान सेंटर&rsquo; में <span className="font-black">आजीवन (Lifetime) लक्ज़री कॉटेज स्टे, ब्रेकफास्ट, लंच, डिनर और हाई-टी</span> पूरी तरह से मुफ़्त पाएं!
          </p>
          <p className="mt-2 text-sm italic text-amber-100">आपकी पीढ़ियों के लिए एक शाही आशियाना।</p>
        </div>

        {/* CTA */}
        <div className="rounded-3xl border-2 border-emerald-400/60 bg-gradient-to-br from-emerald-500/20 via-teal-500/10 to-cyan-500/20 p-6 sm:p-8 text-center" data-testid="vision-final-cta">
          <div className="text-4xl mb-2">🤝</div>
          <h2 className="text-2xl sm:text-3xl font-black">आज ही अपना भविष्य सुरक्षित करें!</h2>
          <p className="mt-2 text-sm sm:text-base text-white/85">कल का समाधान आज के निर्णय पर निर्भर करता है। इस महाक्रांति में अपना डिजिटल सर्टिफिकेट आज ही बुक करें।</p>
          <div className="mt-5 flex flex-wrap gap-3 justify-center">
            <Link to="/samadhan" className="px-6 py-3 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-600 text-white font-black text-sm shadow-lg hover:scale-105 transition" data-testid="vision-cta-book">
              💎 Book My Certificate
            </Link>
            <a href="tel:+919579369830" className="px-6 py-3 rounded-full bg-white/10 border border-white/30 text-white font-black text-sm hover:bg-white/20 transition flex items-center gap-1.5">
              <Phone className="w-4 h-4" /> +91-9579369830
            </a>
          </div>
          <div className="mt-5 pt-4 border-t border-white/10 text-[11px] text-slate-400">
            <div className="font-bold">Powered By: <span className="text-cyan-300">Anant Web Portal</span></div>
            <div>The Visionary: <span className="text-amber-300 font-black">Anil (@freedomanil)</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SamadhanVision;
